import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import './CounselorProfile.css';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import VerifiedBadge from '../assets/icons/VerifiedBadge.svg';
import VerifiedBadgeSmall from '../assets/icons/VerifiedBadgeSmall.svg';
import ClassesMediumOnline from '../assets/icons/ClassesMediumOnline.svg';
import ClassesMediumOffline from '../assets/icons/ClassesMediumOffline.svg';
import ClassesMediumPhone from '../assets/icons/ClassesMediumPhone.svg';
import MessageIcon from '../assets/icons/messageIcon.svg';
import PhoneIcon from '../assets/icons/phoneCalling.svg';
import VideoIcon from '../assets/icons/video-recorder.svg';
import { FaUserCircle, FaRegHeart, FaHeart } from 'react-icons/fa';
import { IoArrowForward, IoArrowBack } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useSaveCounsellorMutation, useUnsaveCounsellorMutation } from '../store/api/userApiSlice';
import { openAuthModal, setCredentials } from '../store/slices/authSlice';

const CounselorProfile = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);
  
  const [data, setData] = useState(location.state?.counselor || null);
    const [saveCounsellor] = useSaveCounsellorMutation();
  const [unsaveCounsellor] = useUnsaveCounsellorMutation();
      const user = useSelector((state) => state.auth.userInfo);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!data && id) {
       setData({
        name: "Sunil Panda",
        bio: "Human Resource Professional",
        role: "Anxiety & Depression Therapist", 
        yearExp: 10,
        rating: 4.9,
        imageUri: "", 
        expert: "Managing Manpower for Fortune companies",
        education: [
          { instituteName: "BPUT", course: "B - Tech", specialization: "Computer Science Engineering", startYear: 2009, passOut: 2013 }
        ],
        keySkills: [{skill: "Communication"}, {skill: "Team Management"}, {skill: "Talent Acquisition"}],
        languages: [{name: "English"}, {name: "Hindi"}, {name: "Odia"}],
        verified: true,
        chatPrice: 20,
        voiceCallPrice: 20,
        sessionPrice: 30
       });
    }
  }, [id, data]);




  if (!data) return <div style={{padding: '100px', textAlign: 'center'}}>Loading...</div>;

  const displayRole = data.role === "counsellor" && data.bio ? data.bio : (data.role || "Career Counselor");
  const imageUrl = (data.profilePictures && data.profilePictures.length > 0) ? data.profilePictures[0] : (data.imageUri || null);

  // Favorite Logic
  const counselorId = data._id || data.id;
  const savedList = user?.savedCounsellors || [];
  const isFavorite = savedList.includes(counselorId);

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    
    if (!user || !token) {
      dispatch(openAuthModal('login'));
      return;
    }

    const action = isFavorite ? unsaveCounsellor : saveCounsellor;
    const payload = { counsellorId: counselorId };

    try {
      const res = await action(payload).unwrap();
      
      // Validation: Ensure the response contains the updated list before dispatching
      let newSavedList = res.savedCounsellors || res.data?.savedCounsellors;

      if (!newSavedList) {
         // Fallback: If API doesn't return list, update locally
         if (isFavorite) {
            newSavedList = savedList.filter(id => id !== counselorId);
         } else {
            newSavedList = [...savedList, counselorId];
         }
      }

      dispatch(setCredentials({
        userInfo: { ...user, savedCounsellors: newSavedList },
        token
      }));
    } catch (error) {
      console.error('Failed to toggle favorite:', error);
    }
  };


  return (
    <>
      <Navbar />
      <div className="counselor-profile-container">
        <button className="back-btn" onClick={() => navigate(-1)}>
            <IoArrowBack size={20} /> Back
        </button>

        <div className="profile-content-wrapper">
            {/* Left Card */}
            <div className="counselor-left-card">
              <div className="counselor-profile-image-wrapper">

                <button className="profile-fav-btn" onClick={toggleFavorite}>
                    {isFavorite ? <FaHeart color='#088579'/> : <FaRegHeart />}
                </button>
             
                       
                {(imageUrl && !imgError) ? (
                  <img 
                    src={imageUrl} 
                    alt={data.name} 
                    className="counselor-profile-image" 
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', color: '#ccc' }}>
                    <FaUserCircle size={120} />
                  </div>
                )}
              </div>

              <div className="counselor-card-content">
                  <div className="counselor-info-header">
                    <h1 className="counselor-name">{data.name || "Counselor Name"}</h1>
                    <p className="counselor-role">{displayRole || "Specialist"}</p>
                  </div>

                  <div className="verified-badge-container">
                     <img src={VerifiedBadge} alt="Verified" className="verified-icon" />
                  </div>

                  <div className="counselor-stats-grid">
                     <div className="profile-exp-badge">
                        {data.yearExp || 10}+ Years Exp
                     </div>
                     <div className="profile-rating">
                        <span>⭐ {data.rating ? parseFloat(data.rating).toFixed(1) : 4.8}</span>
                        <span className="profile-rating-count">({data.numReviews || '0 review'})</span>
                     </div>
                  </div>

                  <div className="pricing-list">
                      <div className="pricing-row">
                          <div className="pricing-label">
                              <img src={MessageIcon} alt="Chat" className="pricing-icon" />
                              Chat
                          </div>
                          <span>{data.chatPrice || 20} coins</span>
                      </div>
                      <div className="pricing-row">
                          <div className="pricing-label">
                              <img src={PhoneIcon} alt="Call" className="pricing-icon" />
                              Voice Call
                          </div>
                          <span>{data.voiceCallPrice || 20} coins / 15min</span>
                      </div>
                      <div className="pricing-row"> 
                          <div className="pricing-label">
                              <img src={VideoIcon} alt="Video" className="pricing-icon" />
                              Book a Session
                          </div>
                          <span>{data.sessionPrice || 30} coins / 30mins</span>
                      </div>
                  </div>

                  <div className="left-action-buttons">
                      <button className="action-pill-btn book-session-btn">
                         BOOK A SESSION <IoArrowForward size={18} />
                      </button>
                      <button className="action-pill-btn">
                         CHAT <img src={MessageIcon} alt="Chat" />
                      </button>
                      <button className="action-pill-btn">
                         CALL <img src={PhoneIcon} alt="Call" />
                      </button>
                  </div>
              </div>
            </div>

            {/* Right Column (Details + Reviews) */}
            <div className="right-column">
                <div className="right-section-block">
                    {/* Tags */}
                    <div className="right-section-tags">
                        {data.keySkills && data.keySkills.length > 0 ? 
                            data.keySkills.map((s, i) => <span key={i} className="skill-chip">{s.skill || s}</span>) 
                            : (
                                <>
                                    <span className="skill-chip">Depression</span>
                                    <span className="skill-chip">Anxiety</span>
                                    <span className="skill-chip">Mental Health</span>
                                </>
                            )
                        }
                    </div>

                    {/* Headline */}
                    <h2 className="right-headline">
                        {data.expert || "Anxiety Counsellor dedicated to helping you feel calmer, stronger, and in control of your life again."}
                    </h2>

                    {/* About Name */}
                    <h3 className="right-section-title">About {data.name}</h3>
                    <p className="right-paragraph">
                        {data.bio}
                    </p>

                    {/* Classes Medium */}
                    <h3 className="right-section-title">Classes medium</h3>
                    <div className="pills-container">
                        <div className="mode-pill">
                            <img src={ClassesMediumOnline} alt="Online" /> 
                            Online
                        </div>
                        <div className="mode-pill">
                            <img src={ClassesMediumOffline} alt="Offline" /> 
                            Offline
                        </div>
                        <div className="mode-pill">
                            <img src={ClassesMediumPhone} alt="Voice Call" /> 
                            Voice Call
                        </div>
                    </div>

                    {/* Languages */}
                    <h3 className="right-section-title">Languages</h3>
                    <div className="pills-container">
                        {data.languages && data.languages.length > 0 ? 
                             data.languages.map((l, i) => {
                                 const name = l.name || l;
                                 let prefix = name.charAt(0);
                                 if(name === "English") prefix = "En";
                                 else if(name === "Hindi") prefix = "ह";
                                 else if(name === "Telugu") prefix = "తె";
                                 // Add others if needed
                                 return <div key={i} className="lang-pill">{prefix} {name}</div>
                             })
                             : <div className="lang-pill">En English</div>
                        }
                    </div>

                    {/* Verified Box */}
                    <div className="verified-box">
                        <h4 className="verified-box-title">
                            <img src={VerifiedBadgeSmall} alt="Verified" style={{height:'24px'}} /> 
                            Verified by us
                        </h4>
                        <p className="verified-box-text">
                           This mentor has been carefully verified by the MentorX team.
Their qualifications, experience, and identity have been reviewed to ensure safe, reliable, and high-quality guidance for students. You can book sessions with confidence and trust.
                        </p>
                    </div>

                    {/* About Class */}
                    <h3 className="right-section-title">About Class</h3>
                    <p className="right-paragraph" style={{marginBottom:0}}>
                        This class is designed to provide personalized career guidance, skill development, and academic support.
                        The sessions are interactive, easy to understand, and focused on real-world success.
                    </p>
                </div>

                {/* Reviews Section */}
                <div className="reviews-section-wrapper">
                    <div className="reviews-header-row">
                        <h3 className="reviews-main-title">Reviews</h3>
                        <div className="reviews-rating-summary">
                             {data.rating} ({data.numReviews}) 
                             <span style={{color:'#FFC107', marginLeft:'4px'}}>⭐⭐⭐⭐⭐</span>
                        </div>
                    </div>
                    
                    <div className="reviews-list-container">
                        {data.reviews && data.reviews.length === 0 && (
                            <p style={{padding:'20px', textAlign:'center'}}>No reviews yet.</p>
                        )}
                        {data.reviews.map((item, index) => (
                            <div className="review-card" key={index}>
                                <div className="review-header-block">
                                    <div className="review-avatar-placeholder">
                                         <div style={{width:'100%', height:'100%', background:'#088579', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                             <FaUserCircle size={24} color="#FFF" />
                                         </div>
                                    </div>
                                    <div className="review-user-info">
                                        <span className="review-username">{item.ufname}</span>
                                        <div className="review-stars">⭐⭐⭐⭐⭐</div>
                                    </div>
                                    {/* <span className="review-tagline-right">Best ever therapist</span> */}
                                </div>
                                
                                <div className="review-body-block">
                                    <p className="review-body">
                                        {item.comment}
                                    </p>
                                    <span className="review-date">Posted : {item.createdAt}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CounselorProfile;
